// extracted by mini-css-extract-plugin
export default {"globalHeader":"hFd1wmhGViI7V6KX9IaT"};